<template>
  <!-- 罪名库详情页 -->
  <div class="zuimindetail">
    <zmdetbanner />
    <div class="cont between">
      <div class="left">
        <zmdet-nav class="compon navfix" @changenav="getzmart" />
        <zmdet
          class="mt30 compon"
          :detlist="detar"
          :det="detob"
          @changenav="getzmart"
        />
        <zmlawtj class="mt30 compon" />
        <zuiminjxwd class="mt30 compon" />
      </div>
      <div class="right">
        <zuimintj class="zmtj1" />
        <zuimintj
          class="zmtj1 mt30"
          tjtitle="刑事辩护相关知识"
          :xhnum="5"
          moniwx="盗窃18万量刑标准是怎样的"
        />
        <zmkssealaw class="zmsea mt30" />
        <tiaolionline class="onlinezx mt30" titext="在线咨询刑事辩护专业律师" />
        <zmgzraank class="zmrank mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import zmdetbanner from "./child/zmdetbanner";
import zmdet from "./child/zmdet.vue";
import zmdetNav from "./components/zmdetNav";
import zmlawtj from "./components/zmlawtj";
import zuiminlb from "views/zuiminlist/child/zuiminlb";
import zuiminjxwd from "views/zuiminlist/child/zuiminjxwd";
import zuimintj from "views/zuiminlist/components/zuimintj";
import zmkssealaw from "views/zuiminlist/components/zmkssealaw";
import zmgzraank from "views/zuiminlist/components/zmgzraank";
import tiaolionline from "views/tiaoliifyul/components/tiaolionline";
export default {
  name: "zuimindetail",
  components: {
    zmlawtj,
    zmdet,
    zmdetbanner,
    zmdetNav,
    zuiminlb,
    zuiminjxwd,
    zuimintj,
    zmkssealaw,
    zmgzraank,
    tiaolionline,
  },
  data() {
    return {
      old_detar: [
        {
          title: "概念",
          cont: "",
          id: 1,
        },
        {
          title: "构成要素",
          cont: "",
          id: 2,
        },
        {
          title: "认定",
          cont: "",
          id: 3,
        },
        {
          title: "立案标准",
          cont: "",
          id: 4,
        },
        {
          title: "量刑标准",
          cont: "",
          id: 5,
        },
        {
          title: "司法解释",
          cont: "",
          id: 6,
        },
        {
          title: "法律意见",
          cont: "",
          id: 7,
        },
      ],
      detar: [],
      detob: {},
      artid: this.$route.query.artid,
    };
  },

  computed: {
    artph() {
      return this.$store.state.jpcol.zuiminart_id;
    },
  },
  beforeMount() {
    this.getzmart();
  },
  methods: {
    getzmart() {
      let data = {
        id: this.artid,
        tab: this.artph,
      };
      this.$http.jpcol
        .getzuimincontent(data)
        .then((res) => {
          let rsdata = res.data;
          document.documentElement.scrollTop = 0;
          
          if (this.artph == 0) {
            this.detob = {};
            let det = this.old_detar;
            det[0].cont = rsdata.gain;
            det[1].cont = rsdata.goucyj;
            det[2].cont = rsdata.rend;
            det[3].cont = rsdata.liangxbz;
            det[4].cont = rsdata.liabz;
            det[5].cont = rsdata.sifjs;
            det[6].cont = rsdata.falyj;
            this.detar = JSON.parse(JSON.stringify(this.old_detar));
          } else {
            this.detar = [];
            this.detob = rsdata;
            console.log("this.detar;", this.detob);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.zuimindetail {
  background: #f8f8f8;
  padding: 50px 0;
  .cont {
    width: 1200px;
    margin: 0 auto;
    align-items: flex-start;
    .left {
      width: 856px;
      .compon {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 2px;
      }
      .navfix {
        position: sticky;
        top: 0;
        z-index: 5;
      }
    }
    .right {
      width: 314px;
      .zmtj1 {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .zmsea {
        width: 100%;
        height: 195px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .onlinezx {
        width: 314px;
        height: 316px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .zmrank {
        width: 100%;
        height: 483px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>